module.exports = __webpack_public_path__ + "src/images/products/allAmerican/82_Knitted Polka Dot Tie.png";